import { render, staticRenderFns } from "./crossevent2.vue?vue&type=template&id=6c4fb4da"
import script from "./crossevent2.vue?vue&type=script&lang=js"
export * from "./crossevent2.vue?vue&type=script&lang=js"
import style0 from "./crossevent2.vue?vue&type=style&index=0&id=6c4fb4da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports